export enum ProbateSections {
  HOME = 'HOME',
  SUBSCRIBER = 'SUBSCRIBER',
  DECEDENT = 'DECEDENT',
  WILL = 'WILL',
  ESTATE = 'ESTATE',
  HEIRS_AND_INTERESTED_PARTIES = 'HEIRS_AND_INTERESTED_PARTIES',
  DOCUMENTS = 'DOCUMENTS',
  FORMS = 'FORMS',
  TAXES = 'TAXES',
  BOND_SURETY = 'BOND_SURETY',
  OTHER = 'OTHER',
}

export enum ProbateAccountSections {
  NOTES = 'NOTES',
  SUPPORT = 'SUPPORT',
  NOTIFICATIONS = 'NOTIFICATIONS',
  MESSAGES = 'MESSAGES',
}

export const ProbateSectionsTitles = {
  [ProbateSections.SUBSCRIBER]: 'Subscriber (YOUR) information',
  [ProbateSections.DECEDENT]: 'Decedent Details',
  [ProbateSections.WILL]: 'Will Details',
  [ProbateSections.ESTATE]: 'Estate Details',
  [ProbateSections.HEIRS_AND_INTERESTED_PARTIES]:
    'Heirs and Interested Parties',
  [ProbateSections.DOCUMENTS]: 'Documents',
  [ProbateSections.FORMS]: 'Forms',
  [ProbateSections.TAXES]: 'Fees and Taxes',
  [ProbateSections.BOND_SURETY]: 'Bond and Surety',
  [ProbateSections.OTHER]: 'Other Information',
} as const;
